import { Component, OnInit, SimpleChanges } from '@angular/core';
import { CrudService, CrudType, IApplicationResponse, ModulesBasedApiSuffix, onActionSubmittedUtil, prepareGetRequestHttpParams, RxjsService } from '@app/shared';
import { MomentService } from '@app/shared/services/moment.service';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { PrimeNgTableVariablesModel } from '../../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-stack-dispach-partition-details',
  templateUrl: './stack-dispach-partition-details.component.html',
})
export class StackDispachPartitionDetailsComponent extends PrimeNgTableVariablesModel implements OnInit {
  constructor(private rxjsService: RxjsService,
    private crudService: CrudService, private momentService: MomentService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Signal History",
      breadCrumbItems: [{ displayName: 'Supervisor Dashboard', relativeRouterUrl: '/event-management/supervisor-dashboard' }, { displayName: 'Operation', relativeRouterUrl: '/event-management/supervisor-dashboard', queryParams: { tab: 7 } }, { displayName: 'Signal History' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Signal History',
            dataKey: 'stackConfigId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            cursorLinkIndex: 0,
            columns: [{ field: 'displayText', header: 'Signal', width: '150px', linkValidKey: 'isLinkEnabled', isLinkwithValid: true },
            { field: 'partitionNo', header: 'Partition', width: '150px' },
            { field: 'partitionCodeName', header: 'Partition Desc', width: '150px' }],
            apiSuffixModel: EventMgntModuleApiSuffixModels.CUSTOMER_ADDREDD_PARTIONID_STACK,
            moduleName: ModulesBasedApiSuffix.EVENT_MANAGEMENT,
          }
        ]
      }
    }
  }

  ngOnInit(): void {
    if (this.config?.data?.occurrenceBookId) {
      this.getSignalHistoryList(null, null, {});
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.config?.data?.occurrenceBookId) {
      this.getSignalHistoryList(null, null, {});
    }
  }

  getSignalHistoryList(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let eventMgntModuleApiSuffixModels: EventMgntModuleApiSuffixModels;
    eventMgntModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.crudService
      .get(
        ModulesBasedApiSuffix.EVENT_MANAGEMENT,
        eventMgntModuleApiSuffixModels,
        this.config?.data?.occurrenceBookId ? this.config?.data?.occurrenceBookId : null,
        false,
        prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
      ).subscribe((data: IApplicationResponse) => {
        this.loading = false;
        this.rxjsService.setGlobalLoaderProperty(false);
        if (data.isSuccess) {
          this.dataList = data.resources;
          this.totalRecords = data.resources.length;
          this.isShowNoRecord = false;
        } else {
          this.dataList = null;
          this.isShowNoRecord = true;
          this.totalRecords = 0;
        }
      });
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.GET:
        let otherParams = {};
        if (Object.keys(this.row).length > 0) {
          if (this.row['searchColumns']) {
            Object.keys(this.row['searchColumns']).forEach((key) => {
              if (key.toLowerCase().includes('date')) {
                otherParams[key] = this.momentService.localToUTC(this.row['searchColumns'][key]);
              } else {
                otherParams[key] = this.row['searchColumns'][key];
              }
            });
          }
          if (this.row['sortOrderColumn']) {
            otherParams['sortOrder'] = this.row['sortOrder'];
            otherParams['sortOrderColumn'] = this.row['sortOrderColumn'];
          }
        }
        this.getSignalHistoryList(row["pageIndex"], row["pageSize"], unknownVar);
      case CrudType.EDIT:
        this.ref.close(row);
        break;
    }
  }

  onActionSubmited(e: any) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  btnCloseClick() {
    this.ref.close();
  }
}